import { render } from "./PersonalCabinet.vue?vue&type=template&id=951bfdd8&scoped=true"
import script from "./PersonalCabinet.vue?vue&type=script&lang=ts"
export * from "./PersonalCabinet.vue?vue&type=script&lang=ts"

import "./PersonalCabinet.vue?vue&type=style&index=0&id=951bfdd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-951bfdd8"

export default script